const VOICE_CONTENT_DATA_STORE_KEY = "voice";

export { VOICE_CONTENT_DATA_STORE_KEY };
//# sourceMappingURL=constant.js.map
